<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">User role settings</div>
</div>

<div class="page-layout padding-large m-margin-none m-padding m-padding-top-largest">
  <!-- <div class="flex margin-bottom">
		<div class="flex-1 flex center">
			<h4>Search Photographers</h4>
		</div>
	</div>

	<div class="flex wrap gap">
		<div class="filter-chip" [ngClass]="!photographerFilters.textSearch ? '' : 'selected'">
			@if (photographerFilters.textSearch) {
				<div class="flex center hover" (click)="openNameFilter()">
					<b class="margin-right-smallest">Name or surname:</b>
					{{ photographerFilters.textSearch }}
				</div>

				<mat-icon class="hover" (click)="cleanFilter('textSearch')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openNameFilter()">
					Name or surname
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!photographerFilters.brands || !photographerFilters.brands.length ? '' : 'selected'">
			@if (photographerFilters.brands && photographerFilters.brands.length) {
				<div class="flex center hover" (click)="openBrandFilterModal()">
					<b class="margin-right-smallest">Brand:</b>

					@for (brand of photographerFilters.brands; track brand; let last = $last) {
						{{ brand.name }}
						@if (!last) {
							,
						}
					}
				</div>
				<mat-icon class="hover" (click)="cleanFilter('brands')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openBrandFilterModal()">
					Brand
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!photographerFilters.contractDate ? '' : 'selected'">
			@if (photographerFilters.contractDate) {
				<div class="flex center hover" (click)="openContractDateFilterModal()">
					<b class="margin-right-smallest">Contract Date:</b>

					{{ photographerFilters.contractDate.from | date: 'dd-MM-yyyy' }} - {{ photographerFilters.contractDate.to | date: 'dd-MM-yyyy' }}
				</div>
				<mat-icon (click)="cleanFilter('contractDate')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openContractDateFilterModal()">
					Contract Date
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!photographerFilters.statuses || !photographerFilters.statuses.length ? '' : 'selected'">
			@if (photographerFilters.statuses && photographerFilters.statuses.length) {
				<div class="flex center hover" (click)="openStatusFilterModal()">
					<b class="margin-right-smallest">Status:</b>

					@for (status of photographerFilters.statuses; track status; let last = $last) {
						{{ status.name }}
						@if (!last) {
							,
						}
					}
				</div>

				<mat-icon (click)="cleanFilter('statuses')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openStatusFilterModal()">
					Status
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>
	</div> -->

  <div class="flex margin-bottom">
    <div class="flex-1 flex center">
      <h4>User role settings</h4>
    </div>
  </div>

  <div class="margin-top-small">
    <div class="flex column end margin-bottom-small">
      <button class="flex center" (click)="openAddUserProfileRoleModal()">
        <mat-icon>add</mat-icon>
        Add user role
      </button>
    </div>

    <!-- <bt-paginator [pageNumber]="photographers.currentPage" [pageSize]="photographers.size" [totalNumber]="photographers.totalCount" (clickPage)="pageEvent($event)"></bt-paginator> -->

    <table class="desktop-only">
      <tr>
        <th>User profile</th>
        <th>Role</th>
        <th>Action</th>
      </tr>
      @for (item of userProfileRoles.items; track item) {
        <tr>
          <td>
            {{ item.userProfile.name }}
          </td>
          <td>
            {{ item.role.name | role }}
          </td>

          <td>
            <div class="flex center full-width">
              <span class="margin-left-small hover flex center primary" (click)="openAddUserProfileRoleModal(item)">
                <i class="fa-solid fa-pen small margin-right-smallest"></i>
                Edit
              </span>
              <span class="margin-left-small hover flex center red" (click)="deleteUserProfileRole(item.id)">
                <i class="fa-solid fa-xmark small margin-right-smallest"></i>
                Remove
              </span>
            </div>
          </td>
        </tr>
      } @empty {
        <div class="flex center bg-light-grey padding-largest justify-center">
          <div class="flex column center gap">
            <i class="fa fa-search fa-2xl margin-bottom grey"></i>
            <span>No data found</span>
          </div>
        </div>
      }
    </table>

    <bt-paginator
      [pageNumber]="userProfileRoles.currentPage"
      [pageSize]="userProfileRoles.size"
      [totalNumber]="userProfileRoles.totalCount"
      (clickPage)="pageEvent($event)"
    ></bt-paginator>
  </div>
</div>

@if (loading) {
  <bt-loader></bt-loader>
}
